import { createTheme as e } from "@mantine/core";
// src/theme/index.ts
var t = [
	"#f8f0ff",
	"#e9d8ff",
	"#d6b8ff",
	"#c197ff",
	"#ab75ff",
	"#9854ff",
	"#8742d8",
	"#7c3aed",
	"#6d28d9",
	"#5b21b6"
], n = e({
	primaryColor: "purple",
	colors: { purple: t },
	autoContrast: !0,
	luminanceThreshold: .3,
	headings: { sizes: { h1: {
		fontSize: "1.125rem",
		fontWeight: "500",
		lineHeight: "2.0"
	} } },
	fontSizes: {
		xs: "0.6875rem",
		sm: "0.875rem",
		md: "0.875rem",
		lg: "1.0rem",
		xl: "1.125rem"
	},
	components: { Modal: { styles: { content: { backgroundColor: "var(--mantine-color-body)" } } } }
});
export { n as benchmarkTheme, t as purpleColors };

//# sourceMappingURL=theme.mjs.map